import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Modal from './Modal';

const ModalBody = ({ className, children, scrollable, modalRef }) => {
  ModalBody.propTypes = {
    children: PropTypes.node,
    scrollable: PropTypes.boolean,
    modalRef: PropTypes.object,
    className: PropTypes.string
  };

  const bodyClass = classNames(className, 'modal-body', {
    'modal-body--scrollable': scrollable
  });

  return (
    <Modal.Consumer>
      {(context) => (
        <div className={bodyClass} ref={modalRef}>
          {typeof children === 'function' ? children(context) : children}
        </div>
      )}
    </Modal.Consumer>
  );
};

export default ModalBody;
